import img from '../../../images/projects/codepen.jpg'

import { useEffect } from 'react';

import paths from '../../../config/paths'

export default function Codepen({ visited }) {

    useEffect(() => {
        visited();
    }, []);

    return(
        <main className="relative flex flex-col justify-evenly">
            <div className='video'>
                <img src={img}></img>
            </div>
            <h2 className='title'>Codepen</h2>
            <p className='content'>Ici se retrouve les différents petits projets que j'ai fait sur Codepen.</p>
            <p className='skills'>HTML/CSS | Javascript</p>
            <div className='project-button'>
                <a className='codepen' target="_blank" href="https://codepen.io/coussecousse/pen/OJraVWd"><i className="fa-brands fa-codepen mr-2"></i>Bouton de contact</a>
            </div>
            <div className='project-button big-buttons'>
                <a href={paths.MLP} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Précédent projet</a>
                <a href={paths.PROJECTS} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Revenir aux projets</a>
                <a href={paths.QUAI_ANTIQUE} className='backProject'>Prochain projet<i className="fa-solid fa-arrow-right ml-2"></i></a>
            </div>
        </main>
    )
}